module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik01NzYgNDQ4cTAtNTMtMzcuNS05MC41dC05MC41LTM3LjUtOTAuNSAzNy41LTM3LjUgOTAuNSAzNy41IDkwLjUgOTAuNSAzNy41IDkwLjUtMzcuNSAzNy41LTkwLjV6bTEwNjcgNTc2cTAgNTMtMzcgOTBsLTQ5MSA0OTJxLTM5IDM3LTkxIDM3LTUzIDAtOTAtMzdsLTcxNS03MTZxLTM4LTM3LTY0LjUtMTAxdC0yNi41LTExN3YtNDE2cTAtNTIgMzgtOTB0OTAtMzhoNDE2cTUzIDAgMTE3IDI2LjV0MTAyIDY0LjVsNzE1IDcxNHEzNyAzOSAzNyA5MXoiIGZpbGw9ImdyZXkiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tag.svg
// module id = 180
// module chunks = 0